// Lib
import { FC } from "react";
// Hooks
import { usePermissions } from "hooks";
// Components
import {
  AuthSettings,
  RoleSettings,
  PurposeTable,
  PaymentSettings,
  ReferralsSettings,
  TimeSlotsSettings,
  ScheduleOrdersSettings,
  GeneralSettings,
  RewardsSettings,
  MinimumOrderDeliveryFeeSettings,
  NotificationsSettings,
  LoyaltyTiersSettings,
} from "./components";
import { ServiceTable } from "./components/Inputs";
// Styled
import { Typography } from "styled/Typography";
import {
  FlexContainer,
  PageHeadingContainer,
  PageTitleContainer,
} from "styled/Box";

export const Settings: FC = () => {
  const {
    canPurposeGet,
    canTimeSlotsGet,
    canPaymentSettingsGet,
    canReferralsSettingsGet,
    canScheduleOrderSettingsGet,
    canLoyaltyTiersSettingsGet,
    isSuperAdminManagement,
  } = usePermissions();

  return (
    <>
      <FlexContainer $fullwidth $column $gap={24}>
        <PageHeadingContainer>
          <PageTitleContainer>
            <Typography.H1>Settings</Typography.H1>
          </PageTitleContainer>
        </PageHeadingContainer>

        <FlexContainer $fullwidth $column $gap={16}>
          <GeneralSettings />

          {isSuperAdminManagement && <MinimumOrderDeliveryFeeSettings />}

          {isSuperAdminManagement && <NotificationsSettings />}

          <AuthSettings />

          <RewardsSettings />

          <RoleSettings />

          {canPaymentSettingsGet && <PaymentSettings />}

          {canPurposeGet && <PurposeTable />}

          <ServiceTable />

          {canScheduleOrderSettingsGet && <ScheduleOrdersSettings />}

          {canTimeSlotsGet && <TimeSlotsSettings />}

          {canReferralsSettingsGet && <ReferralsSettings />}

          {canLoyaltyTiersSettingsGet && <LoyaltyTiersSettings />}
        </FlexContainer>
      </FlexContainer>
    </>
  );
};
